// extracted by mini-css-extract-plugin
export default {"root":"uQCRwP","withoutAvatars":"PrJHHf"};